import { render, staticRenderFns } from "./GridWithServerPaging.vue?vue&type=template&id=253f3c56"
import script from "./GridWithServerPaging.vue?vue&type=script&lang=js"
export * from "./GridWithServerPaging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports